import Vue from 'vue'
import { getGoodsTypeList, getGoodsList } from '@/api/goods/info'

export function getCascadeOfGoodsList() {
  return new Promise((resolve, reject) => {
    getGoodsTypeList().then(resp => {
      let goodsTypeData = []
      const goodsTypeMapOfIdsArray = []
      const goodsMapOfIdsArray = []
      const goodsTypeMapOfNamesArray = []
      const goodsMapOfNamesArray = []
      const goodsMapOfId = []
      const goodsTypeMap = []
      if (resp.rows && resp.rows.length > 0) {
        // 留一份copy传出去
        const goodsTypeList = Vue.prototype._.cloneDeep(resp.rows || [])
        goodsTypeData = resp.rows[0].label === '全部分类' ? resp.rows[0].children : resp.rows
        Vue.prototype.Utils.generateMapOfIdAndIdsArray(goodsTypeData, goodsTypeMapOfIdsArray,
          goodsTypeMapOfNamesArray, goodsTypeMap)
        getGoodsList({
          total: Vue.prototype.CONST.PAGINATION.TOTAL,
          page: Vue.prototype.CONST.PAGINATION.PAGE,
          rows: Vue.prototype.CONST.PAGINATION.MAX_ROWS,
          sort: 'id',
          order: 'desc'
        }).then(resp => {
          let rows = resp.rows || []
          rows = Vue.prototype.Utils.localeCompare(rows, 'name')
          rows.forEach(row => {
            goodsMapOfId[row.id] = row
            const goodsType = goodsTypeMap[row.type_id]
            if (goodsType) {
              goodsType.children = goodsType.children || []
              goodsType.children.push({
                id: row.id,
                label: row.name,
                pid: goodsType.id
              })
            }
            const goodsIdsArray = goodsTypeMapOfIdsArray[row.type_id]
            if (goodsIdsArray && goodsIdsArray.length > 0) {
              const newGoodsIdsArray = Object.assign([], goodsIdsArray)
              newGoodsIdsArray.push(row.id)
              goodsMapOfIdsArray[row.id] = newGoodsIdsArray
            }
            const goodsNamesArray = goodsTypeMapOfNamesArray[row.type_id]
            if (goodsNamesArray && goodsNamesArray.length > 0) {
              const newGoodsNamesArray = Object.assign([], goodsNamesArray)
              newGoodsNamesArray.push(row.name)
              goodsMapOfNamesArray[row.id] = newGoodsNamesArray
            }
          })
          resolve({
            goodsData: goodsTypeData,
            goodsTypeList: goodsTypeList,
            goodsMapOfIdsArray: goodsMapOfIdsArray,
            goodsMapOfNamesArray: goodsMapOfNamesArray,
            goodsMapOfId: goodsMapOfId
          })
        })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/comm-request.js